import { Injectable, Inject } from '@angular/core';
import { TuiNotification, TuiNotificationsService } from '@taiga-ui/core';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(@Inject(TuiNotificationsService)
  private readonly notificationsService: TuiNotificationsService,) { }

  showNotification(title: string, label: string, autoClose: boolean, status: string) {
    if (status == 'info') {
      this.notificationsService
        .show(title, {
          label: label,
          autoClose: autoClose,
          status: TuiNotification.Info
        })
        .subscribe();
    } else if (status == 'warning') {
      this.notificationsService
        .show(title, {
          label: label,
          autoClose: autoClose,
          status: TuiNotification.Warning
        })
        .subscribe();
    } else if (status == 'success') {
      this.notificationsService
        .show(title, {
          label: label,
          autoClose: autoClose,
          status: TuiNotification.Success
        })
        .subscribe();
    } else if (status == 'error') {
      this.notificationsService
        .show(title, {
          label: label,
          autoClose: autoClose,
          status: TuiNotification.Error
        })
        .subscribe();
    }
  }
}
